import { deletePaymentPlan } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Modal, Text, useModalLoadingState, useAlert } from '@frontend/design-system';

export const DeletePlanModal = ({
  onClose,
  onComplete,
  planId,
}: {
  onClose: () => void;
  onComplete: () => void;
  planId: string;
}) => {
  const { t } = useTranslation('payments');
  const { setLoading } = useModalLoadingState();

  const alert = useAlert();
  const handleDeletePaymentPlan = async () => {
    setLoading(true);
    try {
      await deletePaymentPlan(planId);
      alert.success(t('Plan deleted successfully.'));
      onComplete();
    } catch (err) {
      alert.error(t(`Error deleting payment plan. Please try again.`));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal.Header textAlign='left'>{t(`Delete Payment Plan`)}</Modal.Header>
      <Modal.Body css={{ marginTop: theme.spacing(2) }}>
        <Text weight='bold'>
          This will remove all the records of this payment plan.
          <br />
        </Text>
        <Text weight='light' color='subdued' css={{ marginTop: theme.spacing(1) }}>
          Payment plan can only be deleted before any payment has been made.
        </Text>
      </Modal.Body>
      <Modal.Actions
        css={{ button: { width: 'fit-content' }, justifyContent: 'end', marginTop: theme.spacing(2) }}
        onPrimaryClick={handleDeletePaymentPlan}
        primaryLabel={t('Delete')}
        onSecondaryClick={onClose}
        secondaryLabel={t('Cancel')}
        destructive
      />
    </>
  );
};
